"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var Figma = function (_a) {
    var size = _a.size, title = _a.title, color = _a.color, svgProps = __rest(_a, ["size", "title", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "currentColor", strokeWidth: "0" }, svgProps, { width: size || '1rem', height: size || '1rem', viewBox: "0 0 24 24", style: __assign({ color: color }, svgProps.style), xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { id: "figma" },
            react_1.default.createElement("path", { id: "Icon", d: "M8.5 2.5H12V0.5H8.5V2.5ZM11 1.5V8.5H13V1.5H11ZM12 7.5H8.5V9.5H12V7.5ZM8.5 7.5C7.11929 7.5 6 6.38071 6 5H4C4 7.48528 6.01472 9.5 8.5 9.5V7.5ZM8.5 0.5C6.01472 0.5 4 2.51472 4 5H6C6 3.61929 7.11929 2.5 8.5 2.5V0.5ZM11 8.5V15.5H13V8.5H11ZM12 14.5H8.5V16.5H12V14.5ZM8.5 14.5C7.11929 14.5 6 13.3807 6 12H4C4 14.4853 6.01472 16.5 8.5 16.5V14.5ZM8.5 7.5C6.01472 7.5 4 9.51472 4 12H6C6 10.6193 7.11929 9.5 8.5 9.5V7.5ZM11 15.5V19H13V15.5H11ZM8.5 21.5C7.11929 21.5 6 20.3807 6 19H4C4 21.4853 6.01472 23.5 8.5 23.5V21.5ZM11 19C11 20.3807 9.88071 21.5 8.5 21.5V23.5C10.9853 23.5 13 21.4853 13 19H11ZM8.5 14.5C6.01472 14.5 4 16.5147 4 19H6C6 17.6193 7.11929 16.5 8.5 16.5V14.5ZM12 2.5H15.5V0.5H12V2.5ZM15.5 7.5H12V9.5H15.5V7.5ZM18 5C18 6.38071 16.8807 7.5 15.5 7.5V9.5C17.9853 9.5 20 7.48528 20 5H18ZM15.5 2.5C16.8807 2.5 18 3.61929 18 5H20C20 2.51472 17.9853 0.5 15.5 0.5V2.5ZM15.5 14.5C14.1193 14.5 13 13.3807 13 12H11C11 14.4853 13.0147 16.5 15.5 16.5V14.5ZM18 12C18 13.3807 16.8807 14.5 15.5 14.5V16.5C17.9853 16.5 20 14.4853 20 12H18ZM15.5 9.5C16.8807 9.5 18 10.6193 18 12H20C20 9.51472 17.9853 7.5 15.5 7.5V9.5ZM15.5 7.5C13.0147 7.5 11 9.51472 11 12H13C13 10.6193 14.1193 9.5 15.5 9.5V7.5Z" }))));
};
exports.default = Figma;
